import { defineFcm } from '../shared/factory';

export const FCM_PETITIONS_WITH_BLOCKED_SIGNATURE_EXPORT = defineFcm('petitions_with_blocked_signature_export')
	.asString()
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'export-service',
		context: 'export_service',
		description:
			'Comma-separated list of petition_ids, used to prevent certain petitions from being able to have their signatures exported by the starter.',
		import: false,
	});
